// extracted by mini-css-extract-plugin
export default {"buttonDesc":"_1KMfDlr2tDInvbXXyma22W"};